import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import styled from 'styled-components';
import { Wrapper as Tabs, TabsWrapper } from '@spa/shared/components/Unisystem/Tabs/styles';
import { Wrapper as PricingBox } from '@spa/offer/components/PricingBox/Desktop/styles';
import { tabletRange } from '@spa/shared/theme';
export var Main = /*#__PURE__*/styled.main.withConfig({
  componentId: "sc-t1yop1-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;padding-top:", ";padding-bottom:", ";gap:", ";max-width:1200px;margin:0 auto;", ""], function (props) {
  return props.theme.space(32);
}, function (props) {
  return props.theme.space(10);
}, function (props) {
  return props.theme.space(8);
}, tabletRange.samsungTab('landscape')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-inline: ", ";\n  "])), function (props) {
  return props.theme.space(5);
}));
export var Content = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-t1yop1-1"
})(["display:flex;justify-content:space-between;width:100%;"]);
export var LeftSideContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-t1yop1-2"
})(["width:60%;align-self:flex-start;display:flex;flex-direction:column;gap:", ";", "{position:sticky;top:60px;background:white;z-index:2;", "{margin-bottom:", ";}}"], function (props) {
  return props.theme.space(10);
}, Tabs, TabsWrapper, function (props) {
  return props.theme.space(1);
});
export var RightSideContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-t1yop1-3"
})(["width:38%;display:flex;flex-direction:column;gap:", ";", "{margin-top:", ";}"], function (props) {
  return props.theme.space(5);
}, PricingBox, function (props) {
  return props.theme.space(3);
});
export var SectionPlaceholder = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-t1yop1-4"
})(["min-height:400px;"]);